import logoColor from '../../assets/tutela-logo.png';
import logoLight from '../../assets/tutela-logo-light.png';

export default function TutelaLogo({
  className = 'w-10 h-10',
  variant = 'color',
}: {
  className?: string;
  variant?: 'color' | 'light' | 'dark';
}) {
  const src = variant === 'light' ? logoLight : logoColor;

  return (
    <img
      src={src}
      alt="Tutela"
      className={`${className} object-contain`}
    />
  );
}
